<div [hidden]="consulta">
    <div class="row">
        <div class="col-lg-12" style="padding: 0px;">
            <section class="widget">
                <div>
                    <h5>Asigne las evaluaciones de alumnos</h5>
                    <!-- datos -->
                    <div >
                        <dx-data-grid #grid
                            (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                            id="tabla"
                            [columnAutoWidth]="true"
                            [dataSource]="DataGrados"
                            [noDataText]="'Sin Datos'"
                            [showColumnHeaders]="true"
                            (onEditorPreparing)="onRowPrepared($event)"
                            >

                            <dxo-search-panel
                                [visible]="true"
                                [width]="240"
                                placeholder="{{'Buscar' | translate}}">
                            </dxo-search-panel>

                            <dxo-paging [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>
                            <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->

                            <dxo-pager
                                [visible]="false"
                                [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                                [displayMode]="sistemaService.tablaPaginacionModo"
                                [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                                [showInfo]="sistemaService.tablaPaginacionInfo"
                                [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                            </dxo-pager>
                            <dxo-editing mode="cell" [allowUpdating]="true"></dxo-editing>
                            <dxi-column
                                [allowExporting]="false" [allowEditing]="false"
                                caption="Materias"
                                cellTemplate="cellAcciones"
                                alignment="center">
                            </dxi-column>
                            <!-- <dxi-column [showEditorAlways]="!visualizar" caption="Asignación" dataField="tipoasignacionid" [width]="370" [allowEditing]="!visualizar">
                                <dxo-lookup [dataSource]="asignacion" displayExpr="nombre" valueExpr="tipoasignacionid">
                                </dxo-lookup>
                            </dxi-column> -->
                            <dxi-column
                            [allowExporting]="false" [allowEditing]="false"
                            caption="Asignación"
                            cellTemplate="cellAccionesasignacion"
                            [width]="400"
                            alignment="center">
                        </dxi-column>
                            <dxi-column
                                dataField="nivel" [allowEditing]="false"
                                caption="Nivel">
                            </dxi-column>
                            <dxi-column
                                dataField="grado" [allowEditing]="false"
                                caption="Grado">
                            </dxi-column>
                            <dxi-column
                                [allowExporting]="false" [allowEditing]="false"
                                caption="Previsualizar"
                                [width]="300"
                                cellTemplate="cellAccionesmateria"
                                alignment="center">
                            </dxi-column>
                            <!-- Acciones -->
                            <div *dxTemplate="let cell of 'cellAcciones'" >
                                <a matTooltip="Ver" class="tablaBoton" (click)="Formulario(1, cell.data)" *ngIf="cell.data.tipoasignacionid == 2">
                               <i class="fa fa-eye fa-lg" aria-hidden="true"></i>
                                </a>
                                <a matTooltip="Editar" class="tablaBoton separado edit" (click)="Formulario(2,cell.data)" [class.disabled]="visualizar"  *ngIf="sistemaService.permisos.editar && cell.data.tipoasignacionid == 2">
                                    <i class="fa fa-pencil fa-lg" aria-hidden="true"></i>
                                </a>
                                <!-- <a matTooltip="Editar" class="tablaBoton separado edit" (click)="preevisualizar(cell.data)" [class.disabled]="true">
                                    <i class="fa fa-pencil fa-lg" aria-hidden="true"></i>
                                </a> -->
                            </div>
                            <div *dxTemplate="let cellM of 'cellAccionesmateria'">
                                <dx-select-box [items]="cellM.data.listamateriainiciar" [inputAttr]="{ style: 'background-color:'+'red' }" displayExpr="materia" valueExpr="materiaid" [showClearButton]="true" (onValueChanged)="preevisualizar($event, cellM.data)" [inputAttr]="{ 'aria-label': 'Simple Product' }">
                                  <div *dxTemplate="let data of 'dropDownButton'">
                                    <div class="dx-dropdowneditor-icon"></div>
                                  </div>

                                  <div *dxTemplate="let data of 'item'" class="custom-item" style="background-color: {{data.color}};">
                                    <div class="product-name" >{{ data.materia }}</div>
                                  </div>
                                </dx-select-box>
                            </div>
                            <div *dxTemplate="let cellA of 'cellAccionesasignacion'">
                                <dx-select-box [items]="asignacion" displayExpr="nombre" [value]="cellA.data.tipoasignacionid" valueExpr="tipoasignacionid"  (onValueChanged)="vermaterias($event, cellA.data)" [inputAttr]="{ 'aria-label': 'Simple Product' }">
                                </dx-select-box>
                            </div>
                        </dx-data-grid>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>
